import { FieldSelectorController } from './field-selector.controller';
import { FieldSelectorProps } from './field-selector.model';

export const FieldSelector = (props: FieldSelectorProps) => {
  return <FieldSelectorController {...props} />;
};
